var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses},[_c('div',{class:_vm.spinnerClasses},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{class:_vm.iconClasses,attrs:{"type":"ios-loading","size":"18"}}),_vm._v(" "),(_vm.text)?_c('div',{class:_vm.textClasses},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/scroll/loading-component.vue